import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './styles.scss';
import DeveloperDashboard from 'components/dashboard/developerDashboard/';
import PartnerDashboard from 'components/dashboard/partnerDashboard/';

class Dashboard extends Component {
  render() {
    const { currentUser } = this.props;

    if (currentUser) {
      if (currentUser.is_activated === false) {
        return (
          <div className={styles.wrapper}>
            <div className={styles.notActivated}>
              Your partner account has not yet been activated.<br />
              <br />Please contact{' '}
              <a href="mailto:hello@lodplanner.com">hello@lodplanner.com</a> to
              request activation.
            </div>
          </div>
        );
      } else {
        return currentUser.user_type_enum === 2 ? (
          <PartnerDashboard />
        ) : (
          <DeveloperDashboard history={this.props.history} />
        );
      }
    } else {
      return null;
    }
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.users.map[state.sessionSettings.currentUserId]
  };
}

export default connect(mapStateToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/dashboard/index.js